// 需要拆分主url组件 各个容器的获取的url的方法有可能不一样 重写部分方法
import M_GLOBAL_URL from '../../../main/components/url/index.js'
import M_ENV from '../../../main/components/env/index.js'

let G_URL = {
    /**
      * @function getRefUrl
      * @author
      * @description 获取reffer
      * @instance
      * @return {string}
      * @example
      * M_Url.getRefUrl(); //return 'https://a.com';  //从a页面->b页面，此时调用该方法，则返回a页面的url
      */
    getRefUrl: function () {
        if (M_ENV.isWeexNativeInApp) {
            return weex.config.RefUrl ? weex.config.RefUrl : ''
        } else {
            return document && document.referrer ? document.referrer : ''
        }
    },
 
    /**
      * @function getCrtUrl
      * @author
      * @description 获取当前页面url
      * @instance
      * @return {string}
      * @example
      * M_Url.getCrtUrl(); //return 'https://a.com';  
      */
    getCrtUrl: function () {
        if (M_ENV.isWeexNativeInApp) {
            return weex.config.CrtUrl ? weex.config.CrtUrl : ''
        } else {
            return location && location.href ? location.href : ''
        }
    },
 
    /**
      * @function getUrl
      * @author
      * @description [获取当前页面url、referr]
      * @instance
      * @return {Object}
      * @example
      * M_Url.getUrl(); //return {crtUrl: 'https://a.com/b/c.html', refUrl: 'https://a.com'}; 
      */
    getUrl: function () {
        let _this = this,
            ret = {
                crtUrl: _this.getCrtUrl(), // 当前页面url
                refUrl: _this.getRefUrl() // reffer url
            }
             
        return ret
    }
}

export default Object.assign(M_GLOBAL_URL, G_URL)